/***************************************************************
7/19/2017
Alexander Self
Profile Container
- Displays user profiles
***************************************************************/
import { TextInput, Select, AutoComplete, PasswordInput } from '../../inputs';
import { PROFILE_LOCATIONS, TYPES, LEVELS, GRADES, SUBGRADES } from '../../../constants';
import { onDummyComplete, mapEmployeeForAutoComplete, packageDashForm } from '../../../utils';
import { submitProfileToCreate, submitProfileForLogin, fetchPostionType } from '../../../actions/profile_actions';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class ProfileCreate extends Component {
  componentDidMount() {
    if (this.props.positionTypes.length === 0) this.props.fetchPostionType();
  }
  render() {
    return (
      <div>
        <blockquote>
          <span className="flow-text">Profile Create: <b>If an employee will be logging into the application please create a profile, then create a login.</b></span>
        </blockquote>
        <hr />
        <form id={'profile-create-form'} onSubmit={(e) => e.preventDefault() }>
            <div className="row">
              <div className="col s12 m12 l3">
                <TextInput id={'create-profile-firstName'} label={'First Name'} />
              </div>
              <div className="col s12 m12 l3">
                <TextInput id={'create-profile-lastName'} label={'Last Name'} />
              </div>
              <div className="col s12 m12 l3">
                <TextInput id={'create-profile-middleInit'} label={'Middle Initial'} />
              </div>
              <div className="col s12 m12 l3">
                <TextInput id={'create-profile-eid'} label={'Employee ID'} />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12 l3 xl3">
                <div>
                  <label>Position Type</label>
                  <select id={'create-profile-positionType'} className="browser-default">
                    <option value=""></option>
                    {
                      this.props.positionTypes.map((p) => (
                        <option key={p.positionType} value={p.positionType}>{p.positionType}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
              <div className="col s12 m12 l3 xl3">
                <TextInput id={'create-profile-positionTitle'} label={'Position Title'} />
              </div>
              <div className="col s12 m12 l3 xl3">
                <Select id={'create-profile-location'} label={'Location'} opts={PROFILE_LOCATIONS} />
              </div>
              <div className="col s12 m12 l3 xl3">
                <p className="trainer"><input type="checkbox" id={'create-profile-partTime'} />
                <label htmlFor="create-profile-partTime">Part-time</label></p>
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12 l3">
                <Select id={'create-profile-type'} label={'Type'} opts={TYPES} />
              </div>
              <div className="col s12 m12 l3">
                <TextInput id={'create-profile-department'} label={'Department'} />
              </div>
              <div className="col s12 m12 l3">
                <TextInput id={'create-profile-email'} label={'Email'} />
              </div>
              <div className="col s12 m12 l3">
                <TextInput id={'create-profile-phone'} label={'Phone'} />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12 l3">
                <Select id={'create-profile-grade'} label={'Employee Grade'} opts={GRADES} />
              </div>
              <div className="col s12 m12 l3">
                <Select id={'create-profile-subgrade'} label={'Employee Subgrade'} opts={SUBGRADES} />
              </div>
              <div className="col s12 m12 l6">
                <AutoComplete id={'create-profile-managerId'} label={'Manager'}
                  data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={onDummyComplete} />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12 l12">
                <button className="btn btn-large waves-effect waves-light blue" type="submit"
                  onClick={() => this.props.submitProfileToCreate(packageDashForm('profile-create-form'), this.props.employees)}>
                  Submit
                </button>
              </div>
            </div>
          </form>
          <hr />
          <p className="flow-text">Login Form</p>
          <form id={'profile-createAuth-form'} onSubmit={(e) => e.preventDefault() }>
            <div className="row">
              <div className="col s12 m12 l4">
                <TextInput id={'create-login-email'} label={'Email'} />
              </div>
              <div className="col s12 m12 l4">
                <TextInput id={'create-login-eid'} label={'Employee ID'} />
              </div>
              <div className="col s12 m12 l4">
                <Select id={'create-login-level'} label={'Employee Access Level'} opts={LEVELS} />
              </div>
              <div className="col s12 m12 l6">
                <PasswordInput id={'create-login-password'} label={'Password'} />
              </div>
              <div className="col s12 m12 l6">
                <PasswordInput id={'create-login-passwordVerify'} label={'Password Verify'} />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12 l12">
                <button className="btn btn-large waves-effect waves-light blue" type="submit"
                  onClick={() => this.props.submitProfileForLogin(packageDashForm('profile-createAuth-form'), this.props.employees)}>
                  Submit
                </button>
              </div>
            </div>
          </form>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    employees: state.profile.employees,
    positionTypes: state.misc.positionTypes
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submitProfileToCreate,
    submitProfileForLogin,
    fetchPostionType
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ProfileCreate);



/* END */



// WEBPACK FOOTER //
// ./src/components/profiles/create/profile_create.js